import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

class ProjectOverview extends Component {
    render() {
        return(
            // <Fade bottom>
                <section className={'project-overview project-overview--' + (this.props.id % 2 === 0 ? 'even' : 'odd') + ' project-overview--' + this.props.slug + (this.props.project.arrangement === 'vertical' ? ' project-overview--v-padding' : '')}>
                    <Link to={{pathname: '/' + this.props.slug}}>
                        <Fade left={this.props.id % 2 === 0 ? true : false} right={this.props.id % 2 === 0 ? false : true}>
                            <div className="project-overview__image">
                                {this.props.project.image.style === 'cover' ? (
                                    <div className={'image image--' + this.props.project.image.style}>
                                        <div style={{ 'backgroundImage': 'url(./img/' + this.props.slug + '/' + this.props.project.image.src + ')'}} />
                                    </div>
                                    ) : (
                                    <div className={'image image--' + this.props.project.image.style} >
                                        <img src={'./img/' + this.props.slug + '/' + this.props.project.image.src} alt={this.props.slug}/>
                                    </div>
                                )}
                            </div>
                        </Fade>
                        <div className={'project-overview__content project-overview__content--' + this.props.project.arrangement}>
                            <div className="vl vl--left"/>
                            <div>
                                <Fade left={this.props.id % 2 === 0 ? false : true} right={this.props.id % 2 === 0 ? true : false}>
                                    {this.props.project.type && (                    
                                    <h2 dangerouslySetInnerHTML={{ __html: this.props.project.type }}/>)}
                                    <hr/>
                                    <div className="client">
                                        {this.props.project.client && (
                                            <h3 dangerouslySetInnerHTML={{ __html: this.props.project.client }}/>
                                        )}
                                        <div className="hover hover--home">
                                            <FontAwesomeIcon icon={faArrowRight} alt="See more"/>
                                        </div>
                                    </div>
                                </Fade>
                            </div>
                            <div className="vl vl--right"/>
                        </div>
                    </Link>
                </section>
            // </Fade>
        )
    }
}

export default ProjectOverview